import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { EastSlider } from '../EastSlider/EastSlider';

@Component export class SlideTo extends ThemeComponent {

    init() {


        const playBtn = document.querySelectorAll('.product-gallery__play');
        for(const btn of playBtn) {
            btn.addEventListener('click', (e) => {
                const videoIndex = btn.getAttribute('data-video-index');
                if (videoIndex != null) {
                    const videoIndexInt = parseInt(videoIndex, 10);
                    const slider = document.querySelector('.product-gallery') as EastSlider;
                    const sliderSwiper = slider.swiper;
                    sliderSwiper?.slideTo(videoIndexInt);
                }
            });
        }
    }
}
